export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center bg-background-100 pt-16">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-5">
              24小时不打烊爆料站
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight mb-4">
              51每日大赛
              <br />
              全网反差视频精选入口
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-medium mb-6">
              素人网红翻车现场 · 娱乐圈内幕深度追踪
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl">
              51每日大赛作为资深吃瓜群众的深夜专属基地，24小时实时追踪素人网红翻车与娱乐圈不雅内幕。
              反差视频、酒店猛料每日更新不停歇，第一时间带你直击全网大瓜，揭晓不为人知的精彩真相。
              这里是全网最前沿的爆料入口，也是吃瓜爱好者的终极乐园。
            </p>

            <div className="flex flex-wrap items-center gap-6 md:gap-10 mb-8">
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-black text-primary-500">24H</span>
                <span className="text-xs md:text-sm text-foreground-500">实时追踪中</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-black text-primary-500">10000+</span>
                <span className="text-xs md:text-sm text-foreground-500">独家爆料</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-black text-primary-500">匿名</span>
                <span className="text-xs md:text-sm text-foreground-500">安全入口</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 px-7 py-3 bg-foreground-950 text-white text-sm font-semibold rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <span className="w-6 h-6 rounded-full bg-primary-500 flex items-center justify-center">
                  <i className="ri-fire-line text-white text-xs"></i>
                </span>
                立即吃瓜
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="#contact"
                className="inline-flex items-center justify-center px-7 py-3 border-2 border-foreground-300 text-foreground-800 text-sm font-semibold rounded-full hover:border-foreground-800 hover:bg-foreground-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20collage%20of%20social%20media%20screens%20and%20breaking%20news%20headlines%20floating%20in%20dark%20atmospheric%20space%2C%20neon%20pink%20and%20warm%20amber%20light%20streaks%2C%20modern%20internet%20culture%20aesthetic%2C%20stylized%20abstract%20composition%20with%20digital%20elements%2C%20gossip%20and%20entertainment%20news%20visual%20metaphor%2C%20high%20contrast%20moody%20lighting%2C%20editorial%20photography%20style%2C%20no%20text%2C%20clean%20composition&width=800&height=1000&seq=hero-main-visual&orientation=portrait"
                alt="51每日大赛 - 素人网红翻车与娱乐圈内幕追踪主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold text-foreground-800">
                每日更新 · 实时追踪
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}